import { FunctionComponent, ReactElement, useEffect, useState } from 'react'
import { useStyles } from './styles'

import { Icon } from '@conexasaude/icons'
import { Text, getTheme } from '@conexasaude/conexa-hero'
import { CheckPasswordSecurityReturn } from '@/utils/password/types'
import { checkPasswordSecurity } from '@/utils/password/index'

interface PasswordTipsProps {
  password?: string
}

const PasswordTips: FunctionComponent<PasswordTipsProps> = ({ password }) => {
  const styles = useStyles()
  const theme = getTheme()

  const {
    hasAtLeastEightChars,
    hasAtLeastOneSpecialChar,
    hasAtLeastOneNumber,
    hasUpperAndLowerCaseChars,
  } = useValidatePassword(password)

  const chooseIcon = (state: boolean): ReactElement => {
    if (state === undefined || state === null) {
      return (
        <Icon name="bullet" size="small" color={theme.colors.neutral[200]} />
      )
    }

    if (state) {
      return (
        <Icon
          name="success"
          size="small"
          color={theme.colors.feedback.success[300]}
        />
      )
    }

    return (
      <Icon
        name="close"
        size="small"
        color={theme.colors.feedback.error[300]}
      />
    )
  }

  return (
    <div>
      <Text css={styles.title} variant="label">
        Sua senha deve ter:
      </Text>
      <ul css={styles.tipsList}>
        <li className="password-tips__tip">
          {chooseIcon(hasAtLeastEightChars)}
          <Text variant="microCopy">No mínimo, 8 caracteres;</Text>
        </li>

        <li className="password-tips__tip">
          {chooseIcon(hasAtLeastOneSpecialChar)}
          <Text variant="microCopy">Um caracter especial, como @#%;</Text>
        </li>

        <li className="password-tips__tip">
          {chooseIcon(hasAtLeastOneNumber)}
          <Text variant="microCopy">Um número;</Text>
        </li>
        <li className="password-tips__tip">
          {chooseIcon(hasUpperAndLowerCaseChars)}
          <Text variant="microCopy">
            Combinação de letras maiúsculas e minúsculas.
          </Text>
        </li>
      </ul>
    </div>
  )
}

function useValidatePassword(password: string): CheckPasswordSecurityReturn {
  const [passwordSecurity, setPasswordSecurity] =
    useState<CheckPasswordSecurityReturn>({} as CheckPasswordSecurityReturn)

  useEffect(() => {
    if (!password) {
      setPasswordSecurity({} as CheckPasswordSecurityReturn)
      return
    }

    const security = checkPasswordSecurity(password)

    setPasswordSecurity(security)
  }, [password])

  return passwordSecurity
}

export { PasswordTips }
